import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Register the service worker after the app mounts. Production-only — the
// dev server (CRA) doesn't serve a stable /sw.js and registering one in
// development can lead to confusing stale-cache behaviour during HMR.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        // A new service worker may already be sitting waiting if the user
        // returned to a tab that had updated in the background.
        if (registration.waiting && navigator.serviceWorker.controller) {
          showUpdateBanner(registration.waiting);
        }

        // Watch for new service workers being found and installed. When one
        // finishes installing AND there is already an active controller,
        // that means this is a true update (not a first install).
        registration.addEventListener('updatefound', () => {
          const incoming = registration.installing;
          if (!incoming) return;

          incoming.addEventListener('statechange', () => {
            if (incoming.state === 'installed' && navigator.serviceWorker.controller) {
              showUpdateBanner(incoming);
            }
          });
        });
      })
      .catch((err) => {
        console.warn('[Lantern] Service worker registration failed:', err);
      });

    // Reload the page once the new SW has taken control. Guarded so we
    // only reload once even if the controllerchange event fires more than
    // once (e.g. during dev).
    let reloading = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });
  });
}

function showUpdateBanner(waitingWorker) {
  if (document.getElementById('lantern-sw-update-banner')) return;

  const banner = document.createElement('button');
  banner.id = 'lantern-sw-update-banner';
  banner.type = 'button';
  banner.textContent = 'Lantern has been updated — tap here to get the latest version.';
  Object.assign(banner.style, {
    position: 'fixed',
    left: '50%',
    bottom: 'max(16px, env(safe-area-inset-bottom))',
    transform: 'translateX(-50%)',
    maxWidth: 'calc(100% - 32px)',
    padding: '12px 18px',
    background: '#0F2D5E',
    color: '#FFFDF7',
    border: 'none',
    borderRadius: '12px',
    fontFamily: "'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: '14px',
    fontWeight: '700',
    lineHeight: '1.3',
    letterSpacing: '0.2px',
    boxShadow: '0 6px 20px rgba(15, 45, 94, 0.25)',
    cursor: 'pointer',
    zIndex: '2147483000',
  });

  banner.addEventListener('click', () => {
    banner.disabled = true;
    banner.textContent = 'Updating…';
    waitingWorker.postMessage({ type: 'SKIP_WAITING' });
  });

  document.body.appendChild(banner);
}
